import React, { useContext, useEffect, Fragment } from "react";
import Slider from "react-slick";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import { Button } from 'semantic-ui-react'
import axios from 'axios'
import { INote } from "../../../../app/models/note";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { saveAs } from 'file-saver';
import JSZip from "jszip";


import { Image, Icon, Header, Divider, Label } from "semantic-ui-react";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import { _ } from "ag-grid-community";

import config from '../../../../app/api/apiconfig';
import { isPlainObject } from "jquery";

const baseURL = config.app.baseUrl
const thisdlphotourl = baseURL + "CP/Photo/downloadPhotos"


interface IProps {}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  adaptiveWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

async function returnSingleImage(url){

  var newUrl:String = unescape(url);
  var b = new Blob();
  var byteStream = await axios({
      method:"post",
      url:thisdlphotourl,
      //url:"https://gilm-clientportal-test.azurewebsites.net/CP/Photo/downloadPhotos",
      data: {
        url: newUrl
      }
  }).then((response) => {
    var arr=[]
    var bytes = atob(response.data); 
    const byteNumbers = new Array(bytes.length);
    var count = 0;
    for (let i = 0; i < bytes.length; i++) {
      byteNumbers[i] = bytes.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: 'image/png'});
    const data = window.URL.createObjectURL(blob);
    b = blob;
    
  })
  return b
}

async function downloadSingleImage(url){

  var newUrl:String = unescape(url);

  var byteStream = await axios({
      method:"post",
      url:thisdlphotourl,
      //url:"https://gilm-clientportal-test.azurewebsites.net/CP/Photo/downloadPhotos",
      data: {
        url: newUrl
      }
  }).then((response) => {
    var arr=[]
    var bytes = atob(response.data); 
    const byteNumbers = new Array(bytes.length);
    var count = 0;
    for (let i = 0; i < bytes.length; i++) {
      byteNumbers[i] = bytes.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: 'image/png'});
    const data = window.URL.createObjectURL(blob);
    // var zip = new JSZip();
    // zip.file("lol.png",blob)
    // zip.file("lol2.png",blob)

    // zip.file("lol3.png",blob)

    // zip.file("lol4.png",blob)

    // zip.file("lol5.png",blob)

    // zip.generateAsync({type:"blob"}).then(function (blob) { // 1) generate the zip file
    //   saveAs(blob, "hello.zip");                          // 2) trigger the download
    // });
    saveAs(blob,data + ".jpg")
  })
}

function downloadMultipleImages(images,jobno){
  var zip = new JSZip();
 
  for(var i = 0; i< images.length; i ++){
    var blob = returnSingleImage(images[i].FileName)
    zip.file("img" + i + ".jpg",blob)
  }
 
  zip.generateAsync({type:"blob"}).then(function (blob) { // 1) generate the zip file
      saveAs(blob, jobno + ".zip");                          // 2) trigger the download
    });  
}


const WorkOrderEngineerNotes: React.FC<IProps> = props => {
  const workorderStore = useContext(oneOrderStore);
  const { selectedWorkOrderNotes: workorderNotes } = workorderStore;


  
  
  const ImgStyle = {
    width: "250px",
    height: "250px"
  };

  const ReturnNoteHTML = (note: INote) => {
    if (note.FileName == null) {
      return (
        <Image
          style={ImgStyle}
          src="/assets/no-image.png"
          floated="right"
          alt="No image for this note"
        />
      );
    } else {
      return (
        <Image
          style={ImgStyle}
          src={decodeURIComponent(note.FileName)}
          floated="right"
          alt={note.Subject}
        />
      );
    }
  };

  const showNotes = (images: INote[]) => {
    // Get client
    let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!);
    var cli = sessionObj.Client.Name;
    // Set client to hide information
    var hideinfo = (cli === "") ? true : false;
  
    if (images !== null) {
      var notes = images.map(item => {
        // Strip all HTML tags and extract only the text content
        var plainText = item.NoteText;
        if(item.NoteText != null){
           plainText = item.NoteText.replace(/<[^>]*>/g, "").trim();
        }
  
  
        return (
          <Fragment>
            {ReturnNoteHTML(item)}
            <Button onClick={() => downloadSingleImage(item.FileName)}>Download Image</Button>             
            <Button onClick={() => downloadMultipleImages(images, workorderStore.selectedWorkOrder.JobNo)}>Download All Images</Button>
            <Divider horizontal>
              <Header as="h5">
                <Icon name="sticky note outline" />
                Engineers Note for SOR: {item.ServiceTask}
              </Header>
            </Divider>
  
            {/* Display only the cleaned text */}
            {plainText}
  
            <div style={{ position: "absolute", bottom: 0 }}>
              <Divider horizontal />
              {
                (hideinfo !== true) ?
                <Label><Icon name="calendar alternate outline" />{dateFormatter(item.CreatedOn)}</Label>
                : "" 
              }
              {/* 
              (hideinfo !== true) ?
              <Label><Icon name="user" />{item.CreatedBy}</Label>
              : "" 
              */}
            </div>
          </Fragment>
        );
      });
  
      return notes;
    }
  };
  

  useEffect(() => {
    if (workorderNotes.length !== null) {
      showNotes(workorderNotes);
    }
  });

  return (
    <div
      className="ag-theme-material"
      style={{ height: "300px", width: "100%" }}
    >
      <Slider {...settings}>{showNotes(workorderNotes)}</Slider>
    </div>
  );
};

function dateFormatter(params:any) {
  var date = new Date(params);
  return date.toLocaleString();
}

export default observer(WorkOrderEngineerNotes);
